import { appConfig } from '@/config/app.config';

/**
 * The single console gateway — `no-console` is an ESLint error everywhere else.
 * Debug and info are silenced in production; this is also where Sentry would be wired in.
 */
export const logger = {
  debug(...args: unknown[]): void {
    if (appConfig.app.isProduction) return;
    console.debug(...args);
  },
  info(...args: unknown[]): void {
    if (appConfig.app.isProduction) return;
    console.info(...args);
  },
  warn(...args: unknown[]): void {
    console.warn(...args);
  },
  error(...args: unknown[]): void {
    console.error(...args);
  },
};
